import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgreementShowComponent } from './agreement-show.component';
import { AgreementShowModalService } from './agreement-show.service';
import { ModalModule } from 'ngx-bootstrap/modal';

@NgModule({
  declarations: [AgreementShowComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
  ],
  providers: [AgreementShowModalService],
  entryComponents: [AgreementShowComponent],
})
export class AgreementShowModule { }
